import Image from 'components/Image';
import Button, { ButtonProps, ButtonSize, ButtonVariant, ButtonWidth } from '../Button';

export default function AffiliateButton({ image, children, ...props }: ButtonProps & { image: string }) {
  return (
    <Button variant={ButtonVariant.GRAY} width={ButtonWidth.FULL} size={ButtonSize.LARGE} {...props}>
      {children}
      <Image src={image} style={{ height: '20px' }} />
    </Button>
  );
}
